import { CartOrderMergeStrategy } from '../enums/cart-order-merge-strategy.enum';

export class ApplyCartToCurrentDraft {
  static readonly type = '[Order Cart] Apply Cart To Current Draft';

  constructor(public strategy?: CartOrderMergeStrategy) {}
}

export class CreateNewDraftFromCart {
  static readonly type = '[Order Cart] Create New Draft From Cart';
}
